// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale/dashboards\",\"regex\":\"^/([^/]+)/dashboards$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dashboards/:dashboardId\",\"regex\":\"^/([^/]+)/dashboards/([^/]+)$\",\"paramNames\":[\"locale\",\"dashboardId\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/integrations\",\"regex\":\"^/([^/]+)/integrations$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/settings/access-requests\",\"regex\":\"^/([^/]+)/settings/access-requests$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/login\",\"regex\":\"^/([^/]+)/login$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/register\",\"regex\":\"^/([^/]+)/register$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.6";import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn:
    process.env.NEXT_PUBLIC_SENTRY_DSN ||
    'https://7d6c3cd2fe4c99605f2fea2bf0a56aea@o4509915605499904.ingest.us.sentry.io/4509915606810624',

  // MVP Default: Enable tracing with low sample rate to control event volume
  tracesSampleRate: 0.05,

  // Enable logs to be sent to Sentry
  enableLogs: true,

  // MVP stance: Low session replay rates for internal dogfooding
  replaysSessionSampleRate: 0.05, // 5% of sessions (internal only)
  replaysOnErrorSampleRate: 1.0, // always capture a replay when an error occurs

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration({
      maskAllInputs: true, // mask form fields by default
      blockAllMedia: true, // no audio/video
    }),
  ],

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
